import styled from 'styled-components';
import { AddColumnDialogue } from '../../AddColumnDialogue';
import Checkbox from 'monday-ui-react-core/dist/Checkbox';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import Button from 'monday-ui-react-core/dist/Button';
import { useContext, useMemo, useState } from 'react';
import Tooltip from 'monday-ui-react-core/dist/Tooltip';
import InfoIcon from '../../../assets/icons/info.svg';
import { FileContext } from '../../../context/FileContext';
import AssignEmailControllers from './AssignEmailControllers';

const StyledDropdownForSaveIn = styled(Dropdown)`
  width: 167px;
`;

const SaveInDropdownContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    height: 17px;
    width: 17px;
  }
`;

const FontSizeEditorContainer = styled.div`
  display: flex;
  .left.monday-style-button {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .right.monday-style-button {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  .button,
  .size-counter {
    height: 40px;
    width: 40px;
    outline: none;
    border: 1px solid #c5c7d0;
    font-size: 24px;
    color: #676879;
    background-color: transparent;
  }
  .size-counter {
    width: 60px;
    line-height: 40px;
    font-size: 18px;
    text-align: center;
    border-left: none;
    border-right: none;
  }
`;

const StyledTooltip = styled(Tooltip)`
  width: 355px;
  text-align: center;
`;

const TextBoxControllers = ({
  t,
  selectedItem,
  addedFormFields,
  updateFormFields,
  queryData,
}) => {
  const { boardId, boardName, handleFontIncrease, handleFontDecrease } =
    useContext(FileContext);

  const [showAddColumnDialog, setShowAddColumnDialog] = useState({
    show: false,
    type: '',
  });

  const saveInOptions = useMemo(() => {
    const preSeletedColumns = [];

    addedFormFields
      ?.filter(
        (field) => field.itemId === 'text-box' && field.id !== selectedItem?.id,
      )
      ?.forEach((val) => {
        if (val?.column?.value) {
          preSeletedColumns.push(val.column.value);
        }
      });

    const options = queryData?.data?.items[0]?.column_values
      ?.filter(
        (column) =>
          column.type === 'text' && !preSeletedColumns.includes(column.id),
      )
      ?.map((x, index) => {
        return { value: x.id, label: x.title };
      });

    if (Array.isArray(options)) {
      options.push({
        value: 'add-new-column',
        label: `+ ${t('Add new text column')}`,
        onClick: (value) => {
          setShowAddColumnDialog({ show: true, type: 'text' });
        },
      });
    }
    return options;
  }, [queryData?.data?.items, addedFormFields, selectedItem]);

  function handleCheckboxChange(e) {
    const isChecked = e.target.checked;
    selectedItem.required = isChecked;
    updateFormFields([...addedFormFields]);
  }

  function handleSaveInCheckboxChange(e) {
    const isChecked = e.target.checked;
    selectedItem.saveIn = isChecked;
    updateFormFields([...addedFormFields]);
  }

  function handleSaveInOptionsChange(value) {
    if (value?.onClick) {
      return value.onClick();
    }

    selectedItem.column = value;
    updateFormFields([...addedFormFields]);
  }

  const handleCloseDialogue = () => {
    setShowAddColumnDialog({ show: false, type: '' });
  };

  return (
    <>
      {Boolean(showAddColumnDialog?.show) ? (
        <AddColumnDialogue
          handleClose={handleCloseDialogue}
          type={showAddColumnDialog.type}
          boardId={boardId}
        />
      ) : null}
      <Checkbox
        label={t('Save In')}
        checked={selectedItem?.saveIn}
        onChange={handleSaveInCheckboxChange}
      />
      <SaveInDropdownContainer>
        <StyledDropdownForSaveIn
          clearable={false}
          placeholder={t('Select Column')}
          value={selectedItem.column}
          options={saveInOptions}
          disabled={!selectedItem?.saveIn}
          size={Dropdown.size.SMALL}
          className="dropdown-stories-styles_with-chips"
          onChange={handleSaveInOptionsChange}
        />

        <StyledTooltip
          content={`${t(
            'Use this to select where you want this input data saved on',
          )} ${boardName} ${t('Board')}`}
          zIndex={4}
        >
          <img src={InfoIcon} alt="" />
        </StyledTooltip>
      </SaveInDropdownContainer>
      <Checkbox
        label={t('Required')}
        checked={selectedItem?.required}
        onChange={handleCheckboxChange}
      />
      <FontSizeEditorContainer>
        <Button
          kind={Button.kinds.SECONDARY}
          className="button left"
          onClick={handleFontDecrease}
        >
          -
        </Button>
        <span className="size-counter">{selectedItem?.fontSize || 11}</span>
        <Button
          kind={Button.kinds.SECONDARY}
          className="button right"
          onClick={handleFontIncrease}
        >
          +
        </Button>
      </FontSizeEditorContainer>
      <AssignEmailControllers
        t={t}
        hideTipseen
        selectedItem={selectedItem}
        addedFormFields={addedFormFields}
        updateFormFields={updateFormFields}
      />
    </>
  );
};

export default TextBoxControllers;
